import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { ApproveTermsOfUseModal } from '../ApproveTermsOfUseModal/ApproveTermsOfUseModal';
import DefaultLogo from '../Logo/DefaultLogo.png';
import { selectConfig, selectShouldBlockAppForOnboarding } from '../../redux/config/selectors';
import {
  selectCurrentUser,
  selectUiRights,
  selectIsLoggedIn,
  selectApproveTermsOfUseLoading
} from '../../redux/authentication/selectors';

export const AuthRoutesComponent = ({
  component: Component,
  config,
  isLoggedIn,
  uiRights,
  currentUser,
  approveTermsOfUseLoading,
  shouldBlockAppForOnboarding
}) => {
  const location = useLocation();

  useEffect(() => {
    const agencyLogo = config?.tenant_logo?.url_small || config?.tenant_logo?.url;

    if (isLoggedIn) {
      let link = document.querySelector('link[rel~="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = agencyLogo || DefaultLogo;
    }
  }, [config, isLoggedIn]);

  if (!isLoggedIn) {
    return <Navigate to="/signin" state={{ from: location }} />;
  }

  const renderContentWhenLoggedIn = () => {
    if (isLoggedIn === true && (!uiRights || !Object.keys(uiRights).length)) {
      return <React.Fragment />;
    }

    if (currentUser && !currentUser.terms_of_use_approved_at) {
      return (
        <ApproveTermsOfUseModal
          config={config}
          currentUser={currentUser}
          approveTermsOfUseLoading={approveTermsOfUseLoading}
        />
      );
    }

    const ONBOARDING_PATH = '/onboarding';
    const isOnboardingPath = location.pathname === ONBOARDING_PATH;

    // redirect all paths to /onboarding when onboarding is active
    if (shouldBlockAppForOnboarding && !isOnboardingPath) {
      return <Navigate to={ONBOARDING_PATH} replace />;
    }

    // redirect /onboarding to home when onboarding is not active
    if (!shouldBlockAppForOnboarding && isOnboardingPath) {
      return <Navigate to="/" replace />;
    }

    return <Component />;
  };

  return renderContentWhenLoggedIn();
};

const mapStateToProps = (state) => ({
  config: selectConfig(state),
  approveTermsOfUseLoading: selectApproveTermsOfUseLoading(state),
  isLoggedIn: selectIsLoggedIn(state),
  currentUser: selectCurrentUser(state),
  uiRights: selectUiRights(state),
  shouldBlockAppForOnboarding: selectShouldBlockAppForOnboarding(state)
});

export const AuthRoutes = connect(mapStateToProps)(AuthRoutesComponent);
